import { render, staticRenderFns } from "./label-guide.vue?vue&type=template&id=7bfbc2a8&scoped=true"
import script from "./label-guide.vue?vue&type=script&lang=js"
export * from "./label-guide.vue?vue&type=script&lang=js"
import style0 from "./label-guide.vue?vue&type=style&index=0&id=7bfbc2a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bfbc2a8",
  null
  
)

export default component.exports